import type { RelationPermissionsReturn } from '~/types/permissions';
import type { UseRelationPermissionsOptions } from './use-relation-permissions-base';
import { computed } from 'vue';
import { useRelationPermissionsBase } from './use-relation-permissions-base';

export function useM2OPermissions(options: UseRelationPermissionsOptions): RelationPermissionsReturn {
	const {
		permissionsStore,
		currentColId,
		oppositeColId,
		isCreateForm,
		localConstrainedFieldIds,
	} = useRelationPermissionsBase(options);

	// Computed: check local FK write permission based on form mode
	const canWriteLocalFk = computed(() => {
		if (!currentColId.value) return false;
		return isCreateForm.value
			? permissionsStore.canCreateFields(currentColId.value, localConstrainedFieldIds.value)
			: permissionsStore.canUpdateFields(currentColId.value, localConstrainedFieldIds.value);
	});

	// M2O: Constrained FK on CURRENT collection
	return {
		canConnect: computed(() => {
			if (!oppositeColId.value) return false;
			return permissionsStore.canRead(oppositeColId.value) && canWriteLocalFk.value;
		}),
		canCreate: computed(() => {
			if (!oppositeColId.value) return false;
			return permissionsStore.canCreate(oppositeColId.value) && canWriteLocalFk.value;
		}),
		canEdit: computed(() => {
			if (!oppositeColId.value) return false;
			return permissionsStore.canUpdate(oppositeColId.value);
		}),
		canDisconnect: computed(() => {
			if (!oppositeColId.value) return false;
			// Disconnect nulls the FK - needs same permission as connect/create
			return canWriteLocalFk.value;
		}),
	};
}
